const isFlaggingEnabled = process.env.APP_MODE !== 'development';

export default {
  dashboard: {
    path: '/dashboard',
    isDisabled: isFlaggingEnabled,
    isShown: !isFlaggingEnabled,
  },
  account: {
    path: '/account',
    isShown: true,
  },
  profile: {
    path: '/profile',
    isDisabled: isFlaggingEnabled,
    isShown: !isFlaggingEnabled,
  },
  project: {
    path: '/project',
    isShown: true,
    isShownAIChatbot: false,
    isProofreadButton: true,
    subRoutes: {
      'questionnaire-answers': {
        isShown: true,
      },
      interviews: {
        isShown: true,
      },
      'book-specification': {
        isShown: true,
      },
      outline: {
        isShown: true,
      },
      photos: {
        isShown: true,
      },
      chapters: {
        isShown: true,
      },
      'final-proof': {
        isShown: true,
      },
      'style-samples': {
        path: 'style-samples',
        isShown: true,
      },
      'book-sample': {
        path: '/book-sample',
        isShown: true,
      },
    },
  },
  'my-projects': {
    path: '/my-projects',
    isShown: true,
  },
  'project-info': {
    path: '/project-info',
    isDisabled: isFlaggingEnabled,
    isShown: !isFlaggingEnabled,
  },
  /* TODO: ??? my-projects or all-projects ??? */
  'all-projects': {
    path: '/all-projects',
    isShown: true,
    tableColumns: { // TODO: CHECK IF THIS PART IS VALID, IF NOT - DELETE RELATED CODE
      customer: {
        isShown: true,
      },
      projectType: {
        isShown: true,
      },
      editor: {
        isShown: true,
      },
      writer: {
        isShown: !isFlaggingEnabled,
      },
      stage: {
        isShown: !isFlaggingEnabled,
      },
      dueDate: {
        isShown: !isFlaggingEnabled,
      },
    },
    allFiltersNames: { // TODO: CHECK IF THIS PART IS VALID, IF NOT - DELETE RELATED CODE
      'customer.country': {
        isShown: true,
      },
      'customer.name': {
        isShown: true,
      },
      isActive: {
        isShown: true,
      },
      'editor.name': {
        isShown: true,
      },
      'writer.name': {
        isShown: !isFlaggingEnabled,
      },
      deadlineDate: {
        isShown: !isFlaggingEnabled,
      },
    },
  },
  'project-overview': {
    path: '/project-overview',
    isShown: true,
  },
};
